export default "__VITE_ASSET__CBJs4zKB__"